import { store, retrieve, clearStorage } from '@/utils/storage'

const ACCESS_TOKEN_KEY = 'access_token'

export function logout() {
    clearStorage()
}

export function requireAuth(to, from, next) {
    if (!isLoggedIn()) {
        next({ path: '/' })
    } else {
        next()
    }
}

export function getAccessToken() {
    return retrieve(ACCESS_TOKEN_KEY)
}

export function setAccessToken(accessToken) {
    store(ACCESS_TOKEN_KEY, accessToken)
}

export function isLoggedIn() {
    const accessToken = getAccessToken()
    return !!accessToken
}
